import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { ReactComponent as FindAccountantIllustration } from '../../../../assets/images/integrations/find-bookkeeper.svg'

export const FindAccountantWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: ${Spacing.S24};
  position: absolute;
  top: 0;
  left: 0;
`

export const Header = styled.div``

export const TitleWrapper = styled.div`
  max-width: 95%;
`

export const ContentWrapper = styled.div`
  max-width: 250px;
`

export const Illustration = styled(FindAccountantIllustration)`
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
`
